import { apiService } from '../../../services/apiService';
import { API_PATHS } from '../../../utils/apiPaths';
import type { StorefrontUrlSubmissionRow } from '../models/types';
import { mapStorefrontUrlSubmissionRow } from '../utils/utils';

export async function fetchMyStorefrontUrls(): Promise<StorefrontUrlSubmissionRow[]> {
  const res: any = await apiService.get(API_PATHS.GET_MY_STOREFRONT_URLS);
  if (!res?.success) {
    throw new Error(res?.message || 'Failed to load your URLs.');
  }
  const list = Array.isArray(res.data) ? res.data : [];
  return list.map((item: Record<string, unknown>) => mapStorefrontUrlSubmissionRow(item));
}

export async function submitStorefrontUrl(url: string): Promise<StorefrontUrlSubmissionRow> {
  const res: any = await apiService.post(API_PATHS.SUBMIT_STOREFRONT_URL, { url });
  if (!res?.success) {
    throw new Error(res?.message || 'Failed to submit URL.');
  }
  return mapStorefrontUrlSubmissionRow(res.data ?? {});
}
